import React from 'react';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Box from '@nubank/nuds-web/components/Box/Box';
import Image from '@nubank/nuds-web/components/Image/Image';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { useDynamicYieldValues } from '../../../../../../../utils/dynamicYield';

import CloseBtn from './Commons/CloseBtn';
import MainText from './Commons/MainText';
import LinkGat from './Commons/LinkGat';

const StyledBox = styled(Box)`
  gap: 8px;
  
  p {
    flex: 1;
  }
`;

const RateBox = styled(Box)`
  background-color: #820AD1;  ;
  border-radius: 1px 1px 25px 25px;
  margin-top: -24px;
  margin-bottom: 25px;
  padding: 8px;
`;

function PersonalizedRate({ rates }) {
  const { values: dynamicYieldValues } = useDynamicYieldValues();

  return (
    <Box>
      <CloseBtn />
      <MainText />
      {/* IMAGE BLOCK */}
      <StyledBox
        marginTop="6x"
        marginBottom="6x"
        display="flex"
        flexDirection="row"
        alignItems="center"
        paddingRight={{ xs: '24px', md: '48px' }}
        backgroundColor="#F3EDFF"
        paddingVertical="4x"
        borderRadius="25px 25px 0px 0px"
      >
        <Image
          alt="Icono de una tarjeta"
          src="one-step/rtr/credit-card-magic.png"
          webp
          width="98px"
          height="99px"
        />

        <Typography variant="paragraph1" strong>
          Tarjeta de Crédito Nu
          <Typography variant="paragraph1">
            $0 anualidad, MSI y opciones de pago flexibles.
          </Typography>

        </Typography>
      </StyledBox>
      <RateBox>
        <Typography variant="paragraph1" color="white" strong textAlign="center">
          {`¡Y una tasa de interés de ${rates}% solo para ti!`}
        </Typography>
      </RateBox>

      <StyledBox
        marginTop="2x"
        marginBottom="12x"
        display="flex"
        flexDirection="row"
        alignItems="center"
        paddingRight="60px"
        backgroundColor="#F3EDFF"
        paddingVertical="4x"
        borderRadius="25px"
      >
        <Image
          alt="Icono de una tarjeta"
          src="one-step/rtr/debit-card-magic.png"
          webp
          width="98px"
          height="99px"
        />

        <Typography variant="paragraph1" strong>
          Cuenta Nu:
          <Typography variant="paragraph1" tag="span">
            {' '}
            Débito y en la app puedes crecer tus ahorros
            {' '}
          </Typography>
          {`${dynamicYieldValues.dynamicYield}% al año`}
        </Typography>
      </StyledBox>

      <LinkGat />

    </Box>
  );
}

PersonalizedRate.propTypes = {
  rates: PropTypes.number.isRequired,
};

export default PersonalizedRate;
